"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var LayoutSection_1 = require("./LayoutSection");
var Layout = function (_a) {
    var _b;
    var _c = _a.autoSections, autoSections = _c === void 0 ? true : _c, children = _a.children, className = _a.className, _d = _a.direction, direction = _d === void 0 ? 'left' : _d, justifyContent = _a.justifyContent, _e = _a.spacing, spacing = _e === void 0 ? 'compact' : _e, _f = _a.type, type = _f === void 0 ? '1Col' : _f, rest = __rest(_a, ["autoSections", "children", "className", "direction", "justifyContent", "spacing", "type"]);
    var getChildren = function () {
        if (!autoSections)
            return children;
        var parentProps = {};
        var wrappedChildren = utilities_1.wrapChildren(children, LayoutSection_1.LayoutSection, parentProps);
        return wrappedChildren;
    };
    var LayoutClasses = classnames_1.default('Layout', className, (_b = {
            'Layout--1Col': type === '1Col',
            'Layout--2Col': type === '2Col',
            'Layout--3Col': type === '3Col',
            'Layout--4Col': type === '4Col',
            'Layout--island': type === 'island',
            'Layout--leftSupport': type === 'support' && direction === 'left',
            'Layout--rightSupport': type === 'support' && direction === 'right',
            'Layout--compact': spacing === 'compact',
            'Layout--relaxed': spacing === 'relaxed',
            'Layout--noGutter': spacing === 'none'
        },
        _b["Layout--justify-" + justifyContent] = justifyContent,
        _b));
    return (react_1.default.createElement("div", __assign({ className: LayoutClasses }, rest), getChildren()));
};
exports.Layout = Layout;
exports.Layout.Section = LayoutSection_1.LayoutSection;
//# sourceMappingURL=Layout.js.map